export { default } from './FacebookPixelScript';
